import { CLIENT_ENVS } from './constants';
import { providersInvertLogo } from './game';

export function getProviderIcon(
  provider: string,
  mode: 'color' | 'white',
  size: 'small' | 'large',
  invert?: boolean
) {
  const template = `${CLIENT_ENVS.CDN_URL}/logos/{size}/{mode}/{provider}.svg`;

  if (!template) return '';

  const modeV = () => {
    if (providersInvertLogo.includes(provider) && invert) {
      return mode === 'color' ? 'white' : 'color';
    }

    return mode;
  };

  return template
    .replace('{size}', size === 'small' ? 'providers_small' : 'providers')
    .replace('{mode}', modeV)
    .replace('{provider}', provider);
}

export const createUrl = (template: string) => {
  return (icon: string) => {
    if (!template) return '';
    return template.replace('{}', icon);
  };
};

export const getLocaleFlagIcon = createUrl(
  `${CLIENT_ENVS.CDN_URL}/flags/rectangular/{}.svg`
);
export const getCountryFlagIcon = createUrl(
  `${CLIENT_ENVS.CDN_ICON_URL}/ajax/libs/flag-icon-css/3.4.3/flags/1x1/{}.svg`
);
export const getGameCover = createUrl(`${CLIENT_ENVS.CDN_URL}/i/s3/{}.webp`);
export const getPaymentIcon = createUrl(
  `${CLIENT_ENVS.CDN_URL}/logos/payments/white/{}.svg`
);

export const getCDNImageUrl = (url: string) => {
  return `${CLIENT_ENVS.IMG_CDN_URL}${url}`;
};
